<template>
  <!-- <img alt="Vue logo" src="@/assets/logo.png"> -->
  <TextSample></TextSample>
  <div class="cointainer">
    <div class="posts">
      <div class="element"><p>Hi</p></div>
      <div class="element"><p>Hi</p></div>
      <div class="element"><p>Hi</p></div>
      <div class="element"><p>Hi</p></div>
      <div class="element"><p>Hi</p></div>
    </div>
    <div><Container></Container></div>
    
    <div class="posts">
      <div class="element">
        <img src="@/assets/logo.png" alt="@/assets/logo.png">
      </div>
    </div>
  </div>
  <tabla></tabla>


</template>

<script>
import Container from './components/Container.vue';
import TextSample from './components/TextSample.vue';
import tabla from './components/tabla.vue'
export default {
  name: 'App',
  components: {
    Container,TextSample,tabla
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.cointainer{
  display: grid;
  grid-template-columns: repeat(3,1fr);
  border-style: double;
  border-width: 1rem

}
.posts{
  background-color: rgb(59, 42, 107);
  margin: 1rem;
  border-radius: 25px;
  gap: 1rem;
}
.element{
  background-color: rgb(128, 179, 255);
  min-height: 2rem;
  border-style: dotted;
  border-radius: 2rem;
  padding-bottom: 1rem
}
body{
  background-image: url("@/assets/fondo.jpg");
}
@media only screen and (max-width: 600px) {
  p{
    font-variant: normal;
  }
  .cointainer{
  display: block;
  }
}
</style>
